import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import luxuryVillaOverview from '../img/elevation_img_11.avif'; // Replace with your actual image
import luxuryVillaGroundFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import luxuryVillaFirstFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import elegantLiving from '../img/elevation_img_11.avif'; // Replace with your actual image
import grandExterior from '../img/elevation_img_11.avif'; // Replace with your actual image
import './ProjectStyles.css';

const HousePlan40x60 = () => {
  useScrollToTop();
  return (
    <div className='project-container'> {/* Using the general project container style */}
      <h2>Grand 40x60 House Plan (2400 sq ft): Luxurious Living for Extended Families</h2>
      <img className='project-image' src={luxuryVillaOverview} alt="40x60 House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Discover a meticulously designed two-story house plan for a substantial 40x60 sq ft plot (2400 sq ft). This design emphasizes spaciousness, luxurious amenities, and comfortable living for larger or extended families in Patna, Bihar.</p>

        <h3>Design Philosophy: Creating Expansive and Elegant Living Spaces</h3>
        <p>The core of this design is to fully utilize the generous plot size to create a grand and elegant home. The two-story structure allows for expansive living areas, multiple bedrooms with ensuite facilities, and the potential for additional amenities, all while ensuring excellent natural light and ventilation suitable for the Patna climate.</p>

        <h3>Inspiration for Luxurious Family Living</h3>
        <div className='inspiration-gallery'>
          {/* Replace with images inspiring luxurious and spacious family homes */}
          <img src='../img/grand_living_room_design.jpg' alt='Luxury Home Inspiration 1' className='project-image' />
          <img src='../img/gourmet_kitchen_design.jpg' alt='Luxury Home Inspiration 2' className='project-image' />
          <img src='../img/luxurious_master_suite.jpg' alt='Luxury Home Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Expansive and Well-Appointed</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 1200 sq ft)</h4>
          <img className='project-image' src={luxuryVillaGroundFloor} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically features a very spacious living room, a large gourmet kitchen with a separate dining area, a guest suite with an ensuite bathroom, a powder room, and potentially a study or home office. The layout is designed for seamless flow and entertaining.</p>
          <ul>
            <li><strong>Extensive and Elegant Living Room</strong></li>
            <li><strong>Large Gourmet Kitchen with Separate Dining Area</strong></li>
            <li><strong>Guest Suite with Ensuite Bathroom</strong></li>
            <li><strong>Powder Room</strong></li>
            <li><strong>Study/Home Office (Optional)</strong></li>
            <li><strong>Servant's Quarter with Separate Entrance (Optional)</strong></li>
            <li><strong>Grand Entrance Foyer</strong></li>
            <li><strong>Provision for Landscaped Areas and Porch</strong></li>
            <li><strong>Staircase to the First Floor</strong></li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 1200 sq ft)</h4>
          <img className='project-image' src={luxuryVillaFirstFloor} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually accommodates a luxurious master suite with a spacious bedroom, a walk-in closet, and a large ensuite bathroom, along with two or three additional large bedrooms, each with attached bathrooms. A family lounge or entertainment area and balconies are also common features.</p>
          <ul>
            <li><strong>Luxurious Master Suite with Spacious Bedroom, Walk-in Closet, and Large Ensuite Bathroom</strong></li>
            <li><strong>Two or Three Additional Large Bedrooms with Attached Bathrooms</strong></li>
            <li><strong>Family Lounge/Entertainment Area</strong></li>
            <li><strong>Spacious Balconies/Terraces</strong></li>
            <li><strong>Linen/Storage Room</strong></li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> ~1200 sq ft</li>
            <li><strong>First Floor:</strong> ~1200 sq ft</li>
            <li><strong>Total Built Area:</strong> ~2400 sq ft</li>
            <p>*Note: These are approximate figures and can vary significantly based on the specific architectural design and inclusions.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Luxurious Interiors: Space, Light, and Premium Finishes</h3>
        <div className='interior-feature'>
          <h4>Abundant Natural Light and Cross-Ventilation</h4>
          <img className='project-image' src={elegantLiving} alt="Elegant Living Space" loading="lazy" />
          <p>Large windows and strategically placed openings will ensure the interiors are bathed in natural light and benefit from excellent cross-ventilation, creating a comfortable and airy ambiance throughout the villa.</p>
        </div>

        <div className='interior-feature'>
          <h4>Spacious and Well-Defined Zones</h4>
          <p>The generous plot size allows for expansive and well-defined living zones, providing ample space for relaxation, entertainment, and privacy for all family members.</p>
        </div>

        <div className='interior-feature'>
          <h4>Potential for Premium Finishes and Amenities</h4>
          <p>This design allows for the incorporation of premium finishes, high-end fixtures, and additional amenities such as a home theater, gym, or indoor garden, depending on the homeowner's preferences.</p>
        </div>

        {/* Add more interior design considerations for a luxury villa */}
      </div>

      <div className='project-details'>
        <h3>Grand Exterior: Impressive Design and Curb Appeal</h3>
        <img className='project-image' src={grandExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>Impressive Architectural Design</h4>
          <p>The 40x60 plot provides a substantial canvas for an impressive architectural design with strong curb appeal, potentially incorporating features like a grand entrance, multiple balconies, and well-designed landscaping.</p>
        </div>

        <div className='exterior-feature'>
          <h4>High-Quality and Durable Materials</h4>
          <p>The exterior will be designed using high-quality and durable materials that not only enhance the aesthetic appeal but also ensure longevity and low maintenance.</p>
        </div>

        {/* Add more exterior design features */}
      </div>

      <div className='project-details'>
        <h3>Premium Quality Considerations for Your Grand Villa</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Robust and earthquake-resistant Reinforced Concrete structure.</li>
            <li><strong>Exterior Walls:</strong> High-grade brickwork with premium plastering and elegant exterior finishes.</li>
            <li><strong>Roofing:</strong> High-quality, insulated, and waterproof roofing system for maximum comfort and protection.</li>
            <li><strong>Windows and Doors:</strong> Premium-quality, energy-efficient, and secure windows and doors with elegant hardware.</li>
            <li><strong>Flooring:</strong> High-end flooring options such as marble, granite, or premium hardwood.</li>
            <li><strong>Potential for Smart Home Integration:</strong> Provisions for advanced home automation systems.</li>
          </ul>
        </div>

        {/* Optional: Vaastu considerations for a large luxury villa */}
        {/* <h4>Vaastu Shastra Considerations (Optional)</h4>
        <p>With a large plot, meticulous attention can be paid to Vaastu principles to ensure harmony and positive energy flow throughout the expansive home. Careful planning of orientations, room placements, and landscaping can be integrated into the design.</p> */}
      </div>

      {/* Optional: Location and Context in Patna */}
      {/* <div className='project-details'>
        <h3>Ideally Located in Prime Residential Areas of Patna</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This grand 40x60 house plan is ideal for larger plots in prime residential areas of Patna, offering a luxurious and comfortable lifestyle for discerning families.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Suited for larger residential plots in upscale areas of Patna.</li>
            <li>Allows for extensive indoor and outdoor living spaces.</li>
            <li>Designed with consideration for local building regulations and premium material availability.</li>
          </ul>
        </div>
      </div> */}

      <div className='project-details'>
        <h3>Ready to Build Your Dream Luxury Villa?</h3>
        <p>This expansive 40x60 two-story house plan offers a blueprint for a truly luxurious and comfortable home for larger families in Patna. Contact our experienced architects and designers to customize this plan to your specific desires and local building codes.</p>
        {/* Add your contact information or links to architectural services */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Luxury Villa Project</Button>
                </a>
      </div>
    </div>
  );
};

export default HousePlan40x60;